export enum ApplicationStrategy {
  Parts = 'parts',
  Pumps = 'pumps',
}

export interface UIExperiment {
  dmeUserReEngagementEmailCapture: 'none' | 'optional' | 'required'
}

export interface ApplicationContext {
  billingProvider?: string
  catalogCategoryId?: number
  formAction?: string
  insuranceId?: number
  nextPath?: string
  requiresPrescription?: boolean
  manualReviewRequired?: boolean
  shippingEligibilityDays?: number
  strategy?: ApplicationStrategy
  upgradeFee?: boolean
}

export interface ApplicationProps {
  settings?: ApplicationSettings
  context?: ApplicationContext
}

export interface ApplicationSettings {
  experiment?: UIExperiment | null
  isOptimizedDropdownEnabled: boolean
  isPlpEmailCollectionEnabled: boolean
  catalogCategoryId?: number
  displayInvalidRxReasons?: boolean
  milkBagsForPartsBuyers?: boolean
}
